import { render } from "./ChartsDataNew.vue?vue&type=template&id=744bb226&scoped=true"
import script from "./ChartsDataNew.vue?vue&type=script&lang=js"
export * from "./ChartsDataNew.vue?vue&type=script&lang=js"

import "./ChartsDataNew.vue?vue&type=style&index=0&id=744bb226&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744bb226"]])

export default __exports__